import TextareaAutosize from '@mui/material/TextareaAutosize';

export function BaseTextareaAutosize({ ...otherProps }) {
  return <TextareaAutosize {...otherProps} />;
}

export default BaseTextareaAutosize;
